import React from 'react';
import './MeetupsInfoPage.css';
import { Link } from 'react-router-dom';

const MeetupsInfoPage = () => (
  <div className="meetups-info-lander">
    <div className="meetups-hero">
      <h1>Discover Meetups & Travel Groups</h1>
      <p className="subtitle">Find your next adventure or local connection—personality matched or just for fun!</p>
    </div>
    <div className="meetups-info-content">
      <section>
        <h2>What are Local Meets?</h2>
        <p>Local Meets are casual gatherings in your area—coffee chats, walks, or group activities. You can join by requesting an invite from the organiser, or create your own and invite others!</p>
      </section>
      <section>
        <h2>What are Travel Groups?</h2>
        <p>Travel Groups let you plan trips with others to exciting destinations. Start a group, invite friends, or join an existing group. Group creators approve who joins, so you can travel with people you vibe with.</p>
      </section>
      <section>
        <h2>How do I join or create a Meetup?</h2>
        <ul>
          <li>Sign up or log in to see available meetups and travel groups.</li>
          <li>Request to join any group or meetup that interests you.</li>
          <li>Start your own local meet or travel group and invite others!</li>
          <li>Get approved by the organiser and start connecting.</li>
        </ul>
      </section>
      <section>
        <h2>Personality Matching</h2>
        <p>Our unique personality matching helps you find people you'll get along with—but you can join any group, matched or not!</p>
      </section>
      <div className="meetups-cta">
        <Link to="/signup" className="meetups-signup-btn">Sign Up</Link>
        <span>or</span>
        <Link to="/login" className="meetups-login-link">Log In</Link>
      </div>
    </div>
  </div>
);

export default MeetupsInfoPage; 